/* tslint:disable */
/* eslint-disable */
/**
 * Immutable X API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@immutable.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { FeeData } from './fee-data';

/**
 * 
 * @export
 * @interface FeeToken
 */
export interface FeeToken {
    /**
     * 
     * @type {FeeData}
     * @memberof FeeToken
     */
    'data'?: FeeData;
    /**
     * Fee token type. One of ETH/ERC20
     * @type {string}
     * @memberof FeeToken
     */
    'type'?: FeeTokenTypeEnum;
}

export const FeeTokenTypeEnum = {
    Eth: 'ETH',
    Erc20: 'ERC20'
} as const;

export type FeeTokenTypeEnum = typeof FeeTokenTypeEnum[keyof typeof FeeTokenTypeEnum];


